import authFetch from "../authFetch";

const _forexCache = {};
export async function fetchForexRate(from, to) {
  if (!from || !to || from === to) return 1;
  const key = `${from}/${to}`;
  if (_forexCache[key] && Date.now() - _forexCache[key].ts < 600000) return _forexCache[key].rate;
  try {
    const r = await authFetch(`/api/stock?action=forex&from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`);
    const d = await r.json();
    const rate = d.rate || null;
    if (rate) _forexCache[key] = { rate, ts: Date.now() };
    return rate;
  } catch { return null; }
}
